import Frames from "@frog/source/utility/Frames.js"

export default {
    "static": require("./mage-idle-0.png"),
    "idle": {
        "frames": Frames.run({
            "tweentime": 80,
            "images": [
                require("./mage-idle-0.png"),
                require("./mage-idle-0.png"),
                require("./mage-idle-0.png"),
                require("./mage-idle-0.png"),
                require("./mage-idle-0.png"),
                require("./mage-idle-0.png"),
                require("./mage-idle-0.png"),
                require("./mage-idle-0.png"),
                require("./mage-idle-1.png"),
                require("./mage-idle-2.png"),
                require("./mage-idle-3.png"),
                require("./mage-idle-4.png"),
                require("./mage-idle-5.png"),
                require("./mage-idle-5.png"),
                require("./mage-idle-5.png"),
                require("./mage-idle-5.png"),
                require("./mage-idle-6.png"),
                require("./mage-idle-7.png"),
            ]
        })
    },
    "ready": {
        "frames": Frames.run({
            "tweentime": 80,
            "images": [
                require("./mage-selected-3.png"),
                require("./mage-selected-4.png"),
                require("./mage-selected-5.png"),
                require("./mage-selected-6.png"),
                require("./mage-selected-6.png"),
                require("./mage-selected-6.png"),
                require("./mage-selected-6.png"),
                require("./mage-selected-7.png"),
                require("./mage-selected-0.png"),
                require("./mage-selected-0.png"),
                require("./mage-selected-0.png"),
                require("./mage-selected-0.png"),
                require("./mage-selected-1.png"),
                require("./mage-selected-2.png"),
            ]
        })
    },
}
